/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plus-circle': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10 19a9 9 0 100-18 9 9 0 000 18zm0 1c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z" _fill="#1C3B8D"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M9.5 10.5v4.167h1V10.5h4.167v-1H10.5V5.333h-1V9.5H5.333v1H9.5z" _fill="#1C3B8D"/>'
  }
})
